<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
    <p>Angular ng-select is a lightweight all in one UI Select, Multiselect and Autocomplete library. More example can be found on official <a href="https://ng-select.github.io/ng-select#/data-sources" target="_blank">demo</a> page</p>
    <docs-section [content]="componentContent"></docs-section>
</demo-section>
  